import { render, staticRenderFns } from "./EquipmentDetails.vue?vue&type=template&id=784115fe"
import script from "./EquipmentDetails.vue?vue&type=script&lang=js"
export * from "./EquipmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports